import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'

import { reducer as AuthReducer } from '../routes/public/Login'
import { reducer as notifications } from '../modules/notification'

import AppReducer from '../App/reducer'
import configs from "../routes";

let dinamicReducers = {};

addReducers(configs, dinamicReducers)

function addReducers(configs, dinamicReducers) {
    if (configs.reducerConfig) {
        dinamicReducers[configs.reducerConfig.nome] = configs.reducerConfig.reducer
    }
    if (configs.subConfig) {
        configs.subConfig.forEach(((sub, i) => addReducers(sub, dinamicReducers)))
    }
}

export const rootReducer = combineReducers({
    AppReducer,
    form,
    AuthReducer,
    notifications,
    ...dinamicReducers
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js